import { SVGProps, Ref, forwardRef } from 'react';

export const InfoCircleFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 12C1 6.5 3.75 1 12 1s11 5.5 11 11-2.75 11-11 11S1 17.5 1 12m11.9-2H9.5v1.8h1.6v5.7h1.8zM12 8.5A1.25 1.25 0 1 0 12 6a1.25 1.25 0 0 0 0 2.5"
                fill="currentColor"
            />
        </g>
    </svg>
));
InfoCircleFilledSize24Glyph.displayName = 'InfoCircleFilledSize24Glyph';
